import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './breadcrumb-menu.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';

const renderBreadCrumb = (item, isLast, index) => {
    const key = index !== null && index !== void 0 ? index : item.pageName;
    const breadcrumb = item.relativeUrl
        ? x `<a class="breadcrumb-link" href="${item.relativeUrl}">${o(item.pageName)}</a>`
        : x `<span class="breadcrumb-text">${o(item.pageName)}</span>`;
    return isLast
        ? x `<li class="item" aria-current="page" key="${key}">${breadcrumb}</li>`
        : x `<li class="item" key="${key}">${breadcrumb}</li>`;
};
class BreadcrumbMenu extends s {
    constructor() {
        super(...arguments);
        this.showAll = false;
    }
    handleEllipsisClick() {
        this.showAll = true;
    }
    handleEllipsisKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.showAll = true;
        }
    }
    render() {
        const total = this.breadcrumbs.length;
        let visibleItems = [];
        if (total <= 6 || this.showAll) {
            visibleItems = this.breadcrumbs.map((item, index) => renderBreadCrumb(item, index === total - 1, index));
        }
        else {
            const first = renderBreadCrumb(this.breadcrumbs[0], false, 0);
            const second = renderBreadCrumb(this.breadcrumbs[1], false, 1);
            const lastSecond = renderBreadCrumb(this.breadcrumbs[total - 2], false, total - 2);
            const last = renderBreadCrumb(this.breadcrumbs[total - 1], true, total - 1);
            const ellipsis = x `<li class="item ellipsis" key="ellipsis"><span tabindex="0" role="button" @click="${this.handleEllipsisClick}" @keydown="${this.handleEllipsisKeydown}" aria-expanded="${this.showAll}" aria-label="Expand breadcrumbs">...</span></li>`;
            visibleItems = [first, second, ellipsis, lastSecond, last];
        }
        return x `<nav aria-label="Breadcrumb" id="${l(this.navId)}"><ul class="breadcrumb-menu ${this.rtl || isRTL() ? 'rtl' : ''}">${visibleItems}</ul></nav>`;
    }
}
BreadcrumbMenu.styles = css_248z;
__decorate([
    n({ type: Array })
], BreadcrumbMenu.prototype, "breadcrumbs", void 0);
__decorate([
    n({ type: Boolean })
], BreadcrumbMenu.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], BreadcrumbMenu.prototype, "showAll", void 0);
__decorate([
    n({ type: String, attribute: 'nav-id' })
], BreadcrumbMenu.prototype, "navId", void 0);
customElements.define('breadcrumb-menu', BreadcrumbMenu);

export { BreadcrumbMenu };
